var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngagements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC2361",
    fillRule: "evenodd",
    d: "M7.782 1.8c-2.055 0-3.727 1.615-3.727 3.6 0 1.115.528 2.114 1.356 2.774V5.4c0-1.263 1.063-2.29 2.371-2.29s2.372 1.027 2.372 2.29v2.774A3.547 3.547 0 0011.51 5.4c0-1.985-1.671-3.6-3.727-3.6zm0 2.618c-.56 0-1.016.44-1.016.982v6.32l-1.927-.943a1.13 1.13 0 00-1.175.111l-.964.73 4.148 4.007a2.07 2.07 0 001.437.575h3.902c1.123 0 2.033-.88 2.033-1.964v-3.168c0-.63-.464-1.17-1.105-1.287L8.799 9V5.4c0-.542-.456-.982-1.017-.982z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagements);
export default __webpack_public_path__ + "static/media/engagements.aac138dcb9b2412f778d845309aaca48.svg";
export { ForwardRef as ReactComponent };